// extracted by mini-css-extract-plugin
export default {"QrContainer":"Qr_QrContainer__I+e5o","Reader":"Qr_Reader__k69yB"};